// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonPresentationProps } from "@insite/mobius/Button";
import { GridItemProps } from "@insite/mobius/GridItem";
import { css } from "styled-components";
import { xScreen } from "@stoneage/XDL/Utilities";

interface ModalButtonsActionStyles {
    buttonsGridItem?: GridItemProps;
    cancelButton?: ButtonPresentationProps;
    submitButton?: ButtonPresentationProps;
}

export const modalButtonsActionStyles: ModalButtonsActionStyles = {
    buttonsGridItem: {
        width: 12,
        css: css`
            display: flex;
            justify-content: space-between;
            gap: 10px 16px;
            flex-wrap: wrap;
            width: 100%;
            margin-top: 30px;
        `,
    },
    cancelButton: {
        variant: "secondary",
        sizeVariant: "small",
        css: css`
            ${xScreen("lte", "xs")} {
                width: 100%;
                margin-right: 0;
                order: 1;
            }
        `,
    },
    submitButton: {
        variant: "primary",
        sizeVariant: "small",
        css: css`
            ${xScreen("lte", "xs")} {
                width: 100%;
                order: 0;
            }
        `,
    },
};
